import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import logo from './logo.png';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : "http://localhost:8080";

const CancelConfirmationPage = () => {
    const [billingEndDate, setBillingEndDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isCancelling, setIsCancelling] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBillingEndDate = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/billing/subscription/periodend?plan_type=check`, {
                    credentials: "include",
                });

                if (response.ok) {
                    const data = await response.json();
                    // console.log('🔍 CancelConfirmationPage: API response:', data);

                    // Only show cancel confirmation for active subscriptions
                    if (data.cancel_at_period_end) {
                        navigate("/service");
                        return;
                    }

                    setBillingEndDate(data.subscription_period_end);
                } else {
                    setError("Failed to fetch billing information");
                }
            } catch (error) {
                console.error("Error fetching billing end date:", error);
                setError("Failed to fetch billing information please contact support info@timehri.world");
            } finally {
                setLoading(false);
            }
        };

        fetchBillingEndDate();
    }, [navigate]);

    const handleConfirmCancel = async () => {
        setIsCancelling(true);
        try {
            const response = await fetch(`${API_BASE_URL}/billing/subscription/cancel/initiate?plan_type=cancel`, {
                method: "POST",
                credentials: "include",
            });

            if (response.ok) {
                // console.log("Subscription cancelled successfully");
                navigate("/");
            } else {
                setError("Failed to cancel membership please contact support info@timehri.world");
            }
        } catch (error) {
            console.error("Cancel subscription error:", error);
            setError("Failed to cancel membership");
        } finally {
            setIsCancelling(false);
        }
    };

    const handleGoBack = () => {
        navigate("/service");
    };

    const formatDate = (dateString) => {
        if (!dateString) return "Unknown";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/SQUASHJTTSCROWD.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                position: 'relative'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 0
                }}></div>
                <div className="App" style={{ position: 'relative', zIndex: 1 }}>
                    <a href="https://www.timehri.world/music" target="_blank" rel="noopener noreferrer">
                        <img src={logo} alt="Logo" className="logo" />
                    </a>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        fontSize: '18px',
                        color: '#4CAF50'
                    }}>
                        Loading...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            backgroundImage: 'url("https://storage.googleapis.com/tmhimagebucket/SQUASHJTTSCROWD.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            position: 'relative'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                zIndex: 0
            }}></div>
            <div className="App" style={{ position: 'relative', zIndex: 1 }}>
                <a href="https://www.timehri.world/music" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt="Logo" className="logo" />
                </a>

                <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                maxWidth: '500px',
                margin: '0 auto',
                padding: '20px',
                paddingTop: '120px', // Add top padding to avoid logo overlap
                textAlign: 'center'
            }}>
                {error && (
                    <div style={{ color: 'red', marginBottom: '20px', fontFamily: 'CustomFont' }}>
                        {error}
                    </div>
                )}

                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.04)',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                    borderRadius: '14px',
                    padding: '30px',
                    marginBottom: '30px',
                    fontFamily: 'CustomFont',
                    color: '#009e4a'
                }}>
                    <p style={{ marginBottom: '20px', lineHeight: '1.5' }}>
                        Sorry to see you go! You can continue using Dig Assistant until the end of your billing period:
                    </p>
                    <p style={{
                        fontSize: '1.2em',
                        fontWeight: 'bold',
                        color: '#fcd117',
                        marginBottom: '20px'
                    }}>
                        {formatDate(billingEndDate)}
                    </p>
                    <p style={{ fontSize: '0.9em', opacity: '0.8' }}>
                        After this date, your account will revert to the free tier.
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <button
                        onClick={handleGoBack}
                        style={{
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: '#009e4a',
                            padding: '12px 24px',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '16px',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                            e.target.style.background = '#009e4a';
                            e.target.style.color = 'black';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = 'none';
                            e.target.style.color = '#009e4a';
                        }}
                    >
                        Keep Membership
                    </button>

                    <button
                        onClick={handleConfirmCancel}
                        disabled={isCancelling}
                        style={{
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: '#009e4a',
                            padding: '12px 24px',
                            borderRadius: '5px',
                            cursor: isCancelling ? 'not-allowed' : 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '16px',
                            opacity: isCancelling ? 0.6 : 1,
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                            if (!isCancelling) {
                                e.target.style.background = '#009e4a';
                                e.target.style.color = 'black';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!isCancelling) {
                                e.target.style.background = 'none';
                                e.target.style.color = '#009e4a';
                            }
                        }}
                    >
                        {isCancelling ? 'Cancelling...' : 'Cancel Membership'}
                    </button>
                </div>
            </div>
            </div>
        </div>
    );
};

export default CancelConfirmationPage;
